<template>
  <div>
    <a href="https://kf.yayoukj.com/chat/index/newChat/m/65c9d1104f0cb">
      <div class="contact-us">
        <i class="el-icon-message"></i><br/>
        在<br/>线<br/>客<br/>服
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "contact-us",
}
</script>

<style scoped>
.contact-us {
  padding: 10px;
  background: cornflowerblue;
  position: fixed;
  bottom: 40px;
  right: 10px;
  color: #FFF;
}
</style>
